import { render } from "./InterestedLeads.vue?vue&type=template&id=02f7370c&scoped=true"
import script from "./InterestedLeads.vue?vue&type=script&lang=js"
export * from "./InterestedLeads.vue?vue&type=script&lang=js"

import "./InterestedLeads.vue?vue&type=style&index=0&id=02f7370c&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f7370c"]])

export default __exports__